import { Modal, Alert } from "antd"
import { QrReader } from "react-qr-reader"
import { useState, useEffect } from "react"

const QRModal = ({ visible, onCancel }) => {
    const [error, setError] = useState(null)
    const [hasPermission, setHasPermission] = useState(true)

    useEffect(() => {
        if (visible) {
            checkCameraPermission()
        } else {
            setError(null)
            setHasPermission(true)
        }
    }, [visible])

    const checkCameraPermission = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ 
                video: { facingMode: "environment" } 
            })
            stream.getTracks().forEach(track => track.stop())
            setHasPermission(true)
            setError(null)
        } catch (err) {
            console.error("Camera Permission Error:", err)
            setHasPermission(false)
            
            if (err.name === "NotAllowedError") {
                setError("Akses kamera ditolak. Silakan izinkan akses kamera untuk melanjutkan.")
            } else if (err.name === "NotFoundError") {
                setError("Kamera tidak ditemukan. Pastikan perangkat Anda memiliki kamera.")
            } else if (err.name === "NotReadableError") {
                setError("Kamera sedang digunakan oleh aplikasi lain.")
            } else {
                setError(`Gagal mengakses kamera: ${err.message}`)
            }
        }
    }

    const handleError = (err) => {
        console.error("QR Reader Error:", err)
        setError("Terjadi kesalahan saat membaca QR code. Silakan coba lagi.")
    }

    return (
        <Modal 
            title="QR Camera" 
            visible={visible} 
            footer={null} 
            onCancel={() => {
                setError(null)
                onCancel()
            }}
        >
            {error && (
                <Alert
                    message="Error"
                    description={error}
                    type="error"
                    showIcon
                    closable
                    onClose={() => setError(null)}
                    style={{ marginBottom: 16 }}
                />
            )}
            {visible && hasPermission && !error && (
                <QrReader
                    onResult={result => {
                        if (!!result) {
                            window.location = result
                        }
                    }}
                    onError={handleError}
                    constraints={{
                        facingMode: "environment",
                    }}
                    style={{ width: "100%" }}
                />
            )}
            {visible && error && (
                <div style={{ textAlign: "center", padding: "20px" }}>
                    <p>Klik tombol di bawah untuk mencoba lagi</p>
                    <button 
                        onClick={checkCameraPermission}
                        style={{
                            padding: "8px 16px",
                            backgroundColor: "#FFA726",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer"
                        }}
                    >
                        Coba Lagi
                    </button>
                </div>
            )}
        </Modal>
    )
}

export default QRModal
